
export interface Product {
  id: number;
  name: string;
  price: number;
  rating: number;
  reviewCount: number;
  category: string;
  tags: string[];
  images: string[];
  description: string;
  features: string[];
  ingredients: string;
  directions: string;
  relatedProducts: RelatedProduct[];
  inStock: boolean;
}

export interface RelatedProduct {
  id: number;
  name: string;
  price: number;
  image: string;
  slug: string;
}

export const products: Record<string, Product> = {
  "natural-sage-deodorant": {
    id: 1,
    name: "Natural Sage Deodorant",
    price: 16.99,
    rating: 4.8,
    reviewCount: 124,
    category: "Deodorants",
    tags: ["Natural", "Aluminum-Free"],
    images: [
      "https://images.unsplash.com/photo-1608248597279-f99d160bfcbc?auto=format&fit=crop&w=800&q=80",
      "https://images.unsplash.com/photo-1617052611364-1ba68f3b8bc4?auto=format&fit=crop&w=800&q=80",
      "https://images.unsplash.com/photo-1619451683697-8044fe08476e?auto=format&fit=crop&w=800&q=80"
    ],
    description: "Our Natural Sage Deodorant is made with organic ingredients to keep you feeling fresh all day. This aluminum-free formula effectively neutralizes odor without blocking your body's natural detoxification process.",
    features: [
      "100% Natural Ingredients",
      "Aluminum-Free Formula",
      "Long-Lasting Protection",
      "Subtle Sage Scent",
      "No Artificial Fragrances",
      "Cruelty-Free & Vegan"
    ],
    ingredients: "Butyrospermum Parkii (Shea) Butter, Cocos Nucifera (Coconut) Oil, Maranta Arundinacea (Arrowroot) Root Powder, Sodium Bicarbonate, Salvia Officinalis (Sage) Oil, Tocopherol (Vitamin E), Lavandula Angustifolia (Lavender) Oil, Melaleuca Alternifolia (Tea Tree) Oil",
    directions: "Apply a small amount to clean, dry underarms. Allow to warm against skin for a moment to soften before application if needed. Use daily for best results.",
    relatedProducts: [
      {
        id: 5,
        name: "Charcoal Detox Deodorant",
        price: 18.99,
        image: "https://images.unsplash.com/photo-1616594039964-ae9021a400a0?auto=format&fit=crop&w=800&q=80",
        slug: "/product/charcoal-detox-deodorant"
      },
      {
        id: 8,
        name: "Organic Roll-On Deodorant",
        price: 15.99,
        image: "https://images.unsplash.com/photo-1624976172336-6e40d2dce1ae?auto=format&fit=crop&w=800&q=80",
        slug: "/product/organic-roll-on-deodorant"
      },
      {
        id: 6,
        name: "Soothing Aloe Spray",
        price: 14.99,
        image: "https://images.unsplash.com/photo-1608248543803-ba4f8c70ae0b?auto=format&fit=crop&w=800&q=80",
        slug: "/product/soothing-aloe-spray"
      }
    ],
    inStock: true
  },
};

export const productFaqs = {
  "natural-sage-deodorant": [
    {
      question: "Is this product suitable for sensitive skin?",
      answer: "Yes, our Natural Sage Deodorant is specially formulated for sensitive skin. It's free from harsh chemicals, alcohol, and artificial fragrances that can cause irritation."
    },
    {
      question: "How long does this deodorant last?",
      answer: "One stick typically lasts 2-3 months with daily use. The effectiveness lasts throughout the day for most people, though you may need to reapply after intense physical activity."
    },
    {
      question: "Is this an antiperspirant or just a deodorant?",
      answer: "This is a deodorant only, not an antiperspirant. It neutralizes odor but doesn't block sweat glands. This allows your body to detoxify naturally while still smelling fresh."
    },
    {
      question: "What's the difference between this and conventional deodorants?",
      answer: "Unlike conventional products, our Natural Sage Deodorant contains no aluminum, parabens, phthalates, or artificial fragrances. It works with your body's natural processes rather than against them."
    }
  ]
};
